<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" style="background-color:#f8f8f8;">
    <TestEnvironmentBanner />
    <router-view></router-view>
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js'
  import jwt from "@/http/requests/auth/jwt/index.js"
  import TestEnvironmentBanner from '@/components/TestEnvironmentBanner.vue'

  export default {
    components: {
      TestEnvironmentBanner
    },
    watch: {
      '$store.state.theme'(val) {
        this.toggleClassInBody(val)
      },
      loaderActivity(val) {
        if (val) this.$vs.loading();
        else this.$vs.loading.close();
      }
    },
    methods: {
      toggleClassInBody(className) {
        if (className == 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
          document.body.classList.add('theme-dark')
        } else if (className == 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          document.body.classList.add('theme-semi-dark')
        } else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        }
      },
      handleWindowResize() {
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      },
      handleScroll() {
        this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
      },
      startStockTransferCheck() {
        this.$store.dispatch("setNeedStockTransfer");
      },
      disablePinchZoom() {
        document.addEventListener('touchmove', function(event) {
          if (event.scale !== undefined && event.scale !== 1) {
            event.preventDefault();
          }
        }, { passive: false });
      }
    },
    mounted: async function() {
      this.toggleClassInBody(themeConfig.theme);
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);
      this.disablePinchZoom();
    },
    async created() {
      jwt.init()
      window.addEventListener('resize', this.handleWindowResize)
      window.addEventListener('scroll', this.handleScroll)

    },
    destroyed() {
      window.removeEventListener('resize', this.handleWindowResize)
      window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
      loaderActivity: {
        get() {
          return this.$store.getters["loaderActivity"];
        },
        set(val) {
          this.$store.dispatch("setLoader", val);
        }
      },
    }
  }

</script>

<style>
/* Mobil ekranlarda yakınlaştırma sorunlarını giderme ayarları */
html, body {
  touch-action: manipulation;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: none;
}

* {
  -webkit-tap-highlight-color: transparent;
}

input[type=number], input[type=text], input[type=email], input[type=password] {
  font-size: 16px; /* iOS'ta yakınlaştırmayı önlemek için 16px veya daha büyük font kullanılmalı */
}

/* Butonlar ve tıklanabilir alanlar için mobil iyileştirmeleri */
button, .vs-button, [role="button"], a {
  touch-action: manipulation;
}

/* Özellikle yakınlaştırma yapılan alanlar için */
.vs-popup, .mobile-friendly-popup, .vs-dropdown--menu {
  touch-action: pan-x pan-y;
  -ms-touch-action: pan-x pan-y;
}
</style>
